import { render, staticRenderFns } from "./ExamsDetailsTable.vue?vue&type=template&id=4239564e&scoped=true"
import script from "./ExamsDetailsTable.vue?vue&type=script&lang=js"
export * from "./ExamsDetailsTable.vue?vue&type=script&lang=js"
import style0 from "./ExamsDetailsTable.vue?vue&type=style&index=0&id=4239564e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4239564e",
  null
  
)

export default component.exports